<template>
  <div class="iaa-box">
    <div class="circle">
      <img src="../assets/images/homeAfter/iaa-circle.png" alt="iaa-circle" />
    </div>
    <div class="arc-box">
      <div class="arc"></div>
    </div>
    <div class="hidden-xs-only">
      <div class="title animate__animated">
        {{ $t("modelIaaMobility.title") }}<br />{{
          $t("modelIaaMobility.title1")
        }}
      </div>
      <!-- <div class="option-box">
        <div
          @click="optionChange(index)"
          :class="{ active: index == option_active_index }"
          v-for="(item, index) in option_list"
          :key="item"
        >
          {{ item }}
        </div>
      </div> -->
      <div class="swiper-container" id="model-iaa-mobility-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-1.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-2.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-1.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-2.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-1.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-2.png" alt="IAA" />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-control">
        <div class="scrollbar"></div>
        <div class="button-prev button"></div>
        <div class="button-next button"></div>
      </div>
    </div>
    <div class="hidden-sm-and-up">
      <div class="title animate__animated">
        {{ $t("modelIaaMobility.title") }}<br />{{
          $t("modelIaaMobility.title1")
        }}
      </div>
      <!-- <div class="option-box">
        <div
          @click="optionChange(index)"
          :class="{ active: index == option_active_index }"
          v-for="(item, index) in option_list"
          :key="item"
        >
          {{ item }}
        </div>
      </div> -->
      <div class="swiper-container" id="model-iaa-mobility-swiper-mobile">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-1.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-2.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-1.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-2.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-1.png" alt="IAA" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class="image-box">
              <img src="../assets/images/homeAfter/IAA-image-2.png" alt="IAA" />
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>
<script>
import { elementScroll } from "@/utils/index.js";
import Swiper from "swiper";
export default {
  data() {
    return {
      option_list: this.$t("modelIaaMobility.option_list").split("-"),
      option_active_index: 0,
    };
  },
  mounted() {
    this.swiperInit();
    elementScroll(document.querySelector('.title.animate__animated'), 'animate__zoomIn', document.querySelector('.iaa-box'), 'animate__zoomOut', 200)
  },
  methods: {
    //  初始化swiper
    swiperInit() {
      new Swiper("#model-iaa-mobility-swiper", {
        slidesPerView: "auto",
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        spaceBetween: 30,
        slidesOffsetBefore: -85,
        slidesOffsetAfter: -101,
        navigation: {
          nextEl: ".button-next",
          prevEl: ".button-prev",
        },
        scrollbar: {
          el: ".scrollbar",
        },
      });
      new Swiper("#model-iaa-mobility-swiper-mobile", {
        slidesPerView: "auto",
        centeredSlides: true,
        // centeredSlidesBounds: true,
        spaceBetween: 20,
        // slidesOffsetBefore : 20,
        pagination: {
          el: ".swiper-pagination",
        },
      });
    },
    optionChange(index) {
      this.option_active_index = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.iaa-box {
  position: relative;
}
.arc-box {
  position: relative;
  overflow: hidden;
  height: 400px;
}
.arc {
  position: absolute;
  top: 0;
  left: calc((100% - 2000px) / 2);
  right: calc((100% - 2000px) / 2);
  width: 2000px;
  height: 100%;
  background-color: #e8cca7;
  border-radius: 50% 50% 0 0;
  z-index: -1;
  @media (max-width: 768px) {
    left: calc((100% - 600px) / 2);
    right: calc((100% - 600px) / 2);
    width: 600px;
  }
}
.circle {
  position: absolute;
  top: -422px;
  left: 92px;
  z-index: 1;
  > img {
    display: block;
    width: 533px;
  }
  @media (max-width: 768px) {
    top: -34px;
    left: -113px;
    > img {
      width: 292px;
    }
  }
}
//pc样式
.hidden-xs-only {
  margin-top: -400px;
  overflow: hidden;
  .title {
    margin-top: 90px;
    margin-bottom: 29px;
    font-size: 60px;
    font-weight: 700;
    color: #333;
  }
  .option-box {
    background-color: #e8cca7;
    display: flex;
    justify-content: center;
    margin-bottom: 70px;
    > div {
      position: relative;
      margin-right: 24px;
      padding: 11px 30px;
      border: 1px solid #333;
      border-radius: 20px;
      color: #000;
      font-size: 14px;
      cursor: pointer;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        background-color: #13b0b9;
        border-color: #13b0b9;
        color: #fff;
      }
    }
  }
  .swiper-container {
    background-color: #e8cca7;
    .swiper-slide {
      width: auto;
      opacity: 0.5;
      transition: opacity 0.2s;
    }
    .swiper-slide-next,
    .swiper-slide-next + .swiper-slide {
      opacity: 1;
    }
    .image-box {
      width: 500px;
      height: 500px;
      background-color: #b7c1b1;
      > img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .swiper-control {
    background-color: #e8cca7;
    padding: 30px 0 100px;
    > div {
      display: inline-block;
      margin-right: 20px;
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }
    }
    .scrollbar {
      width: 1020px;
      height: 1px;
      background-color: #cbcbcb;
      .swiper-scrollbar-drag {
        background-color: #333;
      }
    }
    .button {
      width: 70px;
      height: 70px;
      background: no-repeat center / 100%;
      cursor: pointer;
    }
    .button-prev {
      background-image: url("../assets/images/left-arrow.png");
    }
    .button-next {
      background-image: url("../assets/images/right-arrow.png");
    }
  }
}
$fontSize: 16px;
//移动端样式
.hidden-sm-and-up {
  margin-top: -400px;
  overflow: hidden;
  .title {
    margin: 30px;
    font-size: 30px;
    font-weight: 700;
    color: #333;
  }
  .option-box {
    display: flex;
    justify-content: center;
    margin: 0 1.5rem 2.5rem 1.5rem;
    > div {
      flex: 1 1 auto;
      position: relative;
      color: #000;
      font-size: 0.75rem;
      font-weight: 700;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        height: 2px;
        bottom: -10px / $fontSize * 1rem;
        background-color: rgba(0, 0, 0, 0.2);
      }
      &.active {
        color: #13b0b9;
      }
      &.active::after {
        background-color: rgb(19, 176, 185);
      }
    }
  }
  .swiper-container {
    background-color: #e8cca7;
    // margin-left: 1.5rem;
    .swiper-slide {
      width: auto;
      opacity: 0.5;
      transition: opacity 0.2s;
    }
    .swiper-slide-active {
      opacity: 1;
    }
    .image-box {
      width: 280px;
      background-color: #b7c1b1;
      > img {
        display: block;
        width: 100%;
      }
    }
  }
  .swiper-pagination {
    position: static;
    padding-top: 16px;
    padding-bottom: 30px;
    background-color: #e8cca7;
    ::v-deep .swiper-pagination-bullet {
      margin: 0 5px;
      width: 5px;
      height: 5px;
      background-color: rgba(51, 51, 51, 0.6);
      border-radius: 50%;
      vertical-align: middle;
    }
    ::v-deep .swiper-pagination-bullet-active {
      padding: 2px;
      background-color: #333;
      background-clip: content-box;
      border: 1px solid #333;
      box-sizing: content-box;
    }
  }
}
</style>